import React, { useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { Button, Card, CardContent, CircularProgress, Grid, TextField, Typography, Tooltip, useMediaQuery } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { InputAdornment, useTheme } from '@material-ui/core';
import { format } from 'date-fns';
import { guardarDatosMatriculas } from 'app/features/Matriculas/matriculasApi';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import addDays from 'date-fns/addDays';
import esLocale from 'date-fns/locale/es';
import Swal from 'sweetalert2';
import { getFechaCancelacionDefault } from 'utils/utils';

export const TabCancelaciones = ({ datos, bloquearBtn, setDatos, setValue, loaderBtnGuardar, setLoaderBtnGuardar, setBloquearBtn, idEstado, setIdEstado, setMatriculas, tpoTramite, datosModificados, fechaInscripcion, tieneDiferenciaEnPago, setTieneDiferenciaEnPago }) => {

  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down('xs'));
  const [errorTelefono, setErrorTelefono] = useState({ display: "none" });
  const [errorTelefonoTexto, setErrorTelefonoText] = useState('');
  const datosPersonalesFiltrados = datosModificados.filter(prop => prop !== 'Celular' || prop !== 'Email');

  const { control, handleSubmit, formState: { errors, isSubmitted }, getValues, reset, register, trigger, setError, } = useForm({
    mode: "onSubmit",
    defaultValues: {
      Email: datos.Email ? datos.Email : '',
      EmailRepetido: datos.EmailRepetido ? datos.EmailRepetido : '',
      fechaCancelacion: getFechaCancelacionDefault(datos.fechaCancelacion, idEstado, datos.Observado),
    }
  });

  const [phone, setPhone] = useState(() => {
    if (datos.caracteristica) {
      return {
        caracteristica: datos.caracteristica,
        celular: datos.Celular || ''
      };
    }
    return parsePhone(datos.Celular || '');
  });

  const onSubmit = async (formValues) => {
    const fecha = new Date(formValues.fechaCancelacion);
    const hoy = new Date();
    hoy.setHours(0, 0, 0, 0);

    const diferenciaMs = fecha - hoy;
    const diferenciaDias = diferenciaMs / (1000 * 60 * 60 * 24);

    if (diferenciaDias <= 0) {
      Swal.fire({
        icon: 'warning', title: 'Rango de fechas inválido', text: 'La fecha de cancelación debe ser posterior al día de hoy.',
      });
      return;
    }

    if (diferenciaDias > 16) {
      Swal.fire({
        icon: 'warning', title: 'Rango de fechas inválido', text: 'El rango de fechas no puede ser mayor a 15 días.',
      });
      return;
    }

    const date = format(new Date(formValues.fechaCancelacion), 'yyyy-MM-dd');

    const merged = {
      ...datos,
      caracteristica: phone.caracteristica,
      Celular: phone.celular,
      fechaCancelacion: date,
      Email: formValues.Email,
      EmailRepetido: formValues.EmailRepetido
    };

    if (isNaN(phone.caracteristica)) {
      setErrorTelefonoText("La Caracteristica del teléfono Celular debe contener solo números")
      setErrorTelefono({ display: "" })
      return false;
    }
    if (isNaN(phone.celular)) {
      setErrorTelefonoText("El Teléfono Celular debe contener solo números")
      setErrorTelefono({ display: "" })
      return false;
    }

    if (idEstado === 6 && datos.fechaCancelacion) {
      const nueva = new Date(date); 
      const [dia, mes, anio] = datos.fechaCancelacion.split('/');
      const vieja = new Date(`${anio}-${mes}-${dia}`);

      nueva.setHours(0, 0, 0, 0);
      vieja.setHours(0, 0, 0, 0);

      if (nueva > vieja) {
        setTieneDiferenciaEnPago(true);
      } else {
        setTieneDiferenciaEnPago(false);
      }
    }
    
    setDatos({ ...merged });

    if(idEstado === 6 ){
      delete merged.fechaCancelacion;
    }

    setLoaderBtnGuardar(true);
    setBloquearBtn(true);
    const isValid = await trigger(['Email', 'EmailRepetido']);

    datos.domicilios.map((domicilio) => {
      domicilio.caracteristica = phone.caracteristica;
      domicilio.celular = phone.celular;
    })

    if (isValid) {
      guardarDatosMatriculas({ datos: JSON.stringify(merged), estado: idEstado, tpo_tramite: Number(localStorage.tpoTramite) }).then(value => {
        setLoaderBtnGuardar(false);
        setBloquearBtn(false);
        if (value.data.resultado) {
          setValue("3");
          localStorage.setItem('idLegajoTemporal', value.data.result.idLegajoTemporal);
        } else {
          Swal.fire({ title: 'Atención', html: value.data.mensaje, icon: 'warning', showCloseButton: true, showCancelButton: false, confirmButtonText: 'Aceptar', cancelButtonText: 'Cancelar', allowOutsideClick: true })
          return false;
        }
      });
    } else {
      setLoaderBtnGuardar(false);
      setBloquearBtn(false);
      setError('form', { type: 'manual', message: 'Please correct the errors before submitting.' });
    }
  }

  function parsePhone(raw) {
    let digits = raw.replace(/\D/g, '');
    if (digits.startsWith('0')) digits = digits.slice(1);
    let caracteristica = '';
    let celular = '';
    for (let areaLen = 2; areaLen <= 4; areaLen++) {
      if (digits.length >= areaLen + 2 + 6 && digits.length <= areaLen + 2 + 8) {
        if (digits.substr(areaLen, 2) === '15') {
          caracteristica = digits.substr(0, areaLen).replace(/^0+/, '');
          celular = digits.substr(areaLen + 2);
          break;
        }
      }
    }
    if (!caracteristica || !celular) {
      if (digits.length === 10) {
        for (let areaLen = 4; areaLen >= 2; areaLen--) {
          const area = digits.substr(0, areaLen).replace(/^0+/, '');
          const sub = digits.substr(areaLen);
          if (sub.length >= 6 && sub.length <= 8) {
            caracteristica = area;
            celular = sub;
            break;
          }
        }
      }
    }
    if (!caracteristica || !celular) {
      if (digits.length >= 8) {
        celular = digits.slice(-8);
        caracteristica = digits.slice(0, -8).replace(/^0+/, '');
      }
    }
    const totalLength = caracteristica.length + celular.length;
    const isValid = totalLength === 10;
    if (!isValid) {
      return { caracteristica: '', celular: '', isValid: false };
    }
    return { caracteristica, celular, isValid: true };
  }

  const handlePhoneChange = (event) => {
    const { name, value } = event.target;
    const cleaned = value.replace(/\D/g, '').slice(0, name === 'caracteristica' ? 4 : 8);
    setPhone((p) => ({ ...p, [name]: cleaned }));
  };

  return (
    <Grid container display='flex' alignItems="center" justifyContent='center'>
      <form onSubmit={handleSubmit(onSubmit)} style={{ width: '100%' }}>
        <Card sx={{ boxShadow: 5, background: '#e4f0ec', width: { xs: '100%', sm: '95%', md: '90%' }, margin: 'auto', borderColor: '#b8daba', borderRadius: '5px', border: '3px solid #b8daba' }}>
          <CardContent sx={{ paddingBottom: '8px !important'}}>
            <Grid container alignItems="center" spacing={2} sx={{ px: { xs: 0, md: 8 }, }}>
              <Grid item xs={12} md={8} display='flex'>
                <Typography variant="h6" component="span" fontWeight={"bold"}>
                  Fecha a partir de la cual desea cancelar la matrícula:
                </Typography>
              </Grid>
              <Grid item xs={12} md={4} mt={1}>
                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={esLocale}>
                  <Controller
                    name="fechaCancelacion"
                    control={control}
                    rules={{ required: "Debe elegir una fecha" }}
                    render={({ field }) => (
                      <DatePicker
                        label="Fecha de cancelacion"
                        disablePast
                        variant={bloquearBtn ? "filled" : "outlined"}
                        minDate={addDays(new Date(), 1)}
                        maxDate={addDays(new Date(), 15)}
                        inputFormat="dd/MM/yyyy"
                        value={field.value}
                        onChange={(newDate) => field.onChange(newDate)}
                        renderInput={(params) => <TextField {...params} fullWidth />}
                        sx={{
                          backgroundColor: bloquearBtn ? '#dddddd' : 'white',
                          fontWeight: 'bold',
                          borderRadius: '6px',
                          '& .MuiOutlinedInput-root': { borderRadius: '6px' },
                          '& .MuiFilledInput-root': { borderRadius: '6px' },
                          '& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline': { borderColor: 'transparent' },
                          '& .MuiFilledInput-root.Mui-disabled:before': { borderBottom: 'none' }
                        }}
                        disabled={bloquearBtn}
                      />
                    )}
                  />
                  {isSubmitted && errors.fechaCancelacion &&
                    <p style={{
                      color: "red",
                      fontSize: "0.75rem",
                      marginTop: "4px"
                    }}>{errors.fechaCancelacion.message}</p>}
                </LocalizationProvider>
              </Grid>
            </Grid>
              <Grid item xs={12} md={12} mt={1}>
                <Typography variant='h6'>
                  Fecha: Como mínimo el día siguiente al envío de la solicitud y máximo hasta 15 días posteriores.
                </Typography>
              </Grid>
          </CardContent>
        </Card>
        <Card sx={{ boxShadow: 5, background: '#e4f0ec', borderColor: '#b8daba', width: { xs: '100%', sm: '95%', md: '90%' }, margin: 'auto', borderRadius: '5px', border: '3px solid #b8daba', mt: 2 }}>
          <CardContent>
            <Grid container spacing={2} display='flex' sx={{ px: { xs: 0, md: 8 }, }}>
              <Grid item xs={12} display='flex'>
                <Typography fontWeight={"bold"}>Completar su email y número de telefono para continuar</Typography>
                {
                  datosPersonalesFiltrados.length > 0 &&
                  <Tooltip
                      title={`Se han modificado los siguientes campos: ${datosPersonalesFiltrados.join(", ")}`}
                      placement="right"
                  >
                      <WarningAmberOutlinedIcon sx={{ color: 'red !important', ml: 1 }} />
                  </Tooltip>
                }
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography fontWeight={'bold'} fontSize={"12px"}>Email</Typography>
                <TextField
                  fullWidth
                  placeholder="Ingrese su email"
                  variant={bloquearBtn ? "filled" : "outlined"}
                  error={!!errors.Email}
                  helperText={errors.Email?.message}
                  FormHelperTextProps={{ sx: { backgroundColor: errors.Email ? '#e4f0ec' : 'inherit', margin: '0px' } }}
                  {...register("Email", {
                    required: "Email es requerido",
                    pattern: {
                      value: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/,
                      message: "Email inválido"
                    }
                  })}
                  sx={{
                    backgroundColor: 'white',
                    borderRadius: '6px',
                    '& input:-webkit-autofill': {
                      boxShadow: '0 0 0 1000px white inset',
                      WebkitTextFillColor: 'black',
                      transition: 'background-color 5000s ease-in-out 0s',
                    },
                    '& .MuiOutlinedInput-root': { borderRadius: '6px' },
                    '& .MuiFilledInput-root': { borderRadius: '6px' },
                    '& .MuiInputBase-input': {
                      paddingTop: bloquearBtn ? '15px' : undefined,
                      paddingBottom: bloquearBtn ? '15px' : undefined,
                    },
                    '& .MuiFilledInput-root.Mui-disabled:before': { borderBottom: 'none' }
                  }}
                  disabled={bloquearBtn}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography fontWeight={'bold'} fontSize={"12px"}>Repetir Email</Typography>
                <TextField
                  fullWidth
                  placeholder="Ingrese su email nuevamente"
                  variant={bloquearBtn ? "filled" : "outlined"}
                  error={!!errors.EmailRepetido}
                  helperText={errors.EmailRepetido?.message}
                  FormHelperTextProps={{ sx: { backgroundColor: errors.EmailRepetido ? '#e4f0ec' : 'inherit', margin: '0px' } }}
                  {...register("EmailRepetido", {
                    required: "Repetición de email es requerida",
                    pattern: {
                      value: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/,
                      message: "Email inválido"
                    },
                    validate: value => value === getValues('Email') || "Los emails no coinciden"
                  })}
                  sx={{
                    backgroundColor: 'white',
                    borderRadius: '6px',
                    '& input:-webkit-autofill': {
                      boxShadow: '0 0 0 1000px white inset',
                      WebkitTextFillColor: 'black',
                      transition: 'background-color 5000s ease-in-out 0s',
                    },
                    '& .MuiOutlinedInput-root': { borderRadius: '6px' },
                    '& .MuiFilledInput-root': { borderRadius: '6px' },
                    '& .MuiInputBase-input': {
                      paddingTop: bloquearBtn ? '15px' : undefined,
                      paddingBottom: bloquearBtn ? '15px' : undefined,
                    },
                    '& .MuiFilledInput-root.Mui-disabled:before': { borderBottom: 'none' }
                  }}
                  disabled={bloquearBtn}
                />
              </Grid>
              
              <Grid item xs={12} md={2} mt={1}>
                <Typography fontWeight={'bold'} fontSize={"12px"}>Caracteristica</Typography>
                <TextField
                  fullWidth
                  name="caracteristica"
                  onChange={handlePhoneChange}
                  value={phone.caracteristica}
                  variant={bloquearBtn ? "filled" : "outlined"}
                  required
                  InputProps={{
                    startAdornment: <InputAdornment position="start">0</InputAdornment>,
                    pattern: "[0-9]+",
                    maxLength: 5
                  }}
                  type="text"
                  sx={{
                    backgroundColor: 'white',
                    borderRadius: '6px',
                    '& input:-webkit-autofill': {
                      boxShadow: '0 0 0 1000px white inset',
                      WebkitTextFillColor: 'black',
                      transition: 'background-color 5000s ease-in-out 0s',
                    },
                    '& .MuiOutlinedInput-root': { borderRadius: '6px' },
                    '& .MuiFilledInput-root': { borderRadius: '6px' },
                    '& .MuiInputBase-input': {
                      paddingTop: bloquearBtn ? '15px' : undefined,
                      paddingBottom: bloquearBtn ? '15px' : undefined,
                    },
                    '& .MuiFilledInput-root.Mui-disabled:before': { borderBottom: 'none' }
                  }}
                  disabled={bloquearBtn}
                />
              </Grid>
              <Grid item xs={12} md={5} mt={1}>
                <Typography fontWeight={'bold'} fontSize={"12px"}>Celular</Typography>
                <TextField
                  fullWidth
                  name="celular"
                  onChange={handlePhoneChange}
                  value={phone.celular}
                  variant={bloquearBtn ? "filled" : "outlined"}
                  required
                  InputProps={{
                    startAdornment: <InputAdornment position="start">15</InputAdornment>,
                  }}
                  type="text"
                  sx={{
                    backgroundColor: 'white',
                    borderRadius: '6px',
                    '& input:-webkit-autofill': {
                      boxShadow: '0 0 0 1000px white inset',
                      WebkitTextFillColor: 'black',
                      transition: 'background-color 5000s ease-in-out 0s',
                    },
                    '& .MuiOutlinedInput-root': { borderRadius: '6px' },
                    '& .MuiFilledInput-root': { borderRadius: '6px' },
                    '& .MuiInputBase-input': {
                      paddingTop: bloquearBtn ? '15px' : undefined,
                      paddingBottom: bloquearBtn ? '15px' : undefined,
                    },
                    '& .MuiFilledInput-root.Mui-disabled:before': { borderBottom: 'none' }
                  }}
                  disabled={bloquearBtn}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
        <Grid container>
          <Grid item md={6} xs={6} sx={{ mt: 3 }} >
            <Button startIcon={<ArrowBackIosIcon />} onClick={() => setValue("1")} variant="contained" type="submit" color="error" disabled={bloquearBtn}>
              Atras
            </Button>
          </Grid>
          <Grid item md={6} xs={6}>
            <Grid sx={{ mt: 3 }} container justifyContent="flex-end">
              <Button disabled={bloquearBtn} endIcon={<ArrowForwardIosIcon />} type='submit' variant="contained" color="secondary">
                {loaderBtnGuardar ? (isXs ? (<CircularProgress size={25} />) : (<><CircularProgress size={25} /> Continuar </>)) : ('Continuar')}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </Grid>
  );
};